module.exports = __webpack_public_path__ + "static/angle-select.b941e725da99e09e73d9d16f20fc2d29.svg";